/* FFC $50 free U.S. shipping progress. Shopify cart quantities update via theme events. */
(() => {
  const goal = 5000;
  const format = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: 'USD'
  }).format(cents / 100);

  const update = (totalCents) => {
    const total = Math.max(0, Number(totalCents) || 0);
    const remaining = Math.max(0, goal - total);
    const percentage = Math.min(100, Math.round(total / goal * 100));
    document.querySelectorAll('[data-ffc-free-shipping-progress]').forEach((widget) => {
      const message = widget.querySelector('[data-ffc-free-shipping-message]');
      const fill = widget.querySelector('[data-ffc-free-shipping-fill]');
      const track = widget.querySelector('[data-ffc-free-shipping-track]');
      const current = widget.querySelector('[data-ffc-free-shipping-current]');
      if (message) {
        message.textContent = remaining > 0
          ? `You're ${format(remaining)} away from FREE U.S. shipping!`
          : "You've unlocked FREE U.S. shipping!";
      }
      if (fill) fill.style.width = percentage + '%';
      if (track) track.setAttribute('aria-valuenow', String(Math.min(total, goal) / 100));
      if (current) current.textContent = format(total);
      widget.dataset.cartTotal = String(total);
    });
  };

  const start = () => {
    if (window.eventBus && typeof window.eventBus.on === 'function') {
      window.eventBus.on('update:cart:drawer', (cart) => {
        if (cart && typeof cart.total_price !== 'undefined') update(cart.total_price);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
